import { Box, Theme, useMediaQuery } from '@mui/material';
import { FC, useCallback, useRef } from 'react';

import { PieceAssetSize } from '@apiContract';
import { CameraCapture } from '@components/CameraCapture';
import { getPieceAsset } from 'src/utils/piece';

import { CapturePiece } from '../../types';
import sx from './styles';

type Props = {
  onPhoto: (photo: string) => void;
  lastPiece?: CapturePiece;
  onLastPieceClick: () => void;
};

const CameraPhoto: FC<Props> = ({ onPhoto, lastPiece, onLastPieceClick }) => {
  const matches = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const flashRef = useRef<HTMLDivElement | null>(null);
  const photo =
    lastPiece?.editImage ||
    getPieceAsset(lastPiece?.piece?.pieceAssets || [], PieceAssetSize.Medium)?.url ||
    (lastPiece?.photo instanceof File ? URL.createObjectURL(lastPiece?.photo) : lastPiece?.photo);

  const capture = useCallback((param: string) => {
    onPhoto(param);
    if (flashRef.current) {
      flashRef.current.classList.add('flash');
      setTimeout(() => flashRef?.current?.classList.remove('flash'), 300);
    }
  }, [onPhoto])

  const previewSize = matches ? '60px' : '110px';
  return (
    <Box sx={{ display: 'contents' }}>
      <CameraCapture
        capture={capture}
      />

      <Box ref={flashRef} sx={sx.flash} />

      {photo && (
        <Box
          component="button"
          onClick={onLastPieceClick}
          sx={{ ...sx.img(previewSize), border: 'none', p: 0, cursor: 'pointer', background: 'none' }}
          aria-label="View last captured piece"
        >
          <Box
            component="img"
            sx={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 'inherit' }}
            src={photo}
            alt="Last captured piece"
          />
        </Box>
      )}
    </Box>
  );
};

export default CameraPhoto;
